import * as React from 'react'
import { INode } from 'shared/types/tree'
import { ConfirmCommitButton } from 'shared/ui'
import { useUpdateStudentFacing } from '../tree/TreeRequests'

export function StudentFacingToggle({
  node,
  initialDisabled,
}: {
  node: INode
  initialDisabled?: boolean
}) {
  const updateStudentFacing = useUpdateStudentFacing()
  const [disabled, setDisabled] = React.useState(initialDisabled)
  if (!node.body) return null

  function doIt(updateFun: (n: INode) => Promise<unknown>) {
    setDisabled(true)
    updateFun(node).then(() => {
      setDisabled(false)
    })
  }

  function confirmButton(
    label: string,
    action: (n: INode) => Promise<unknown>,
  ) {
    return (
      <ConfirmCommitButton
        disabled={disabled}
        style={{ color: 'darkorchid' }}
        variant={'outlined'}
        onClick={() => doIt(action)}
      >
        <>{label}</>
      </ConfirmCommitButton>
    )
  }

  if (node.body.studentFacing) {
    return confirmButton('Hide From Students', () =>
      updateStudentFacing(false, node),
    )
  }
  return confirmButton('Make Student Facing', () =>
    updateStudentFacing(true, node),
  )
}
